import './ReidentificationModal.scss';

import React, { useEffect } from 'react';
import { ModalComponent } from 'components/modal/modalComponent';
import { formatText } from 'core/i18n';
import { doTagShowReidentificationModal } from './tagging';
import RedentificationID from 'assets/icons/reidentification-id.svg';

export const ReidentificationModal = ({ showModal, handleCancel, handleContinue }) => {
    useEffect(() => {
        showModal && doTagShowReidentificationModal();
    }, [showModal]);

    return (
        <ModalComponent
            isOpen={showModal}
            className="reidentification-modal-step3"
            closeAction={handleCancel}
            onCancel={handleCancel}
            confirmText={formatText('button-understood')}
            onConfirm={handleContinue}
            isConfirmDisabled={!showModal}
        >
            <img src={RedentificationID} alt="reidentification-id" className="modal-body__img" />
            <p className="modal-body__title">{formatText('errorIdentificationModal-youNeedToIdentifyYourselfAgain')}</p>
            <p>{formatText('errorIdentificationModal-seemsThereIsAnErrorWithYourIdentification')}</p>
        </ModalComponent>
    );
};
